import MuiButton from "./MuiButton";
const MButton = {
  MuiButton
}
export default MButton;
